//src/layouts/MainLayout.js
import React from "react";
import Navbar from "../components/pages/Layout/Navbar";
import Footer from "../components/pages/Layout/Footer";

export default function MainLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
